import classNames from "classnames/bind";
import { useEffect, useState } from "react";

import styles from "../../../styles/avaliacoes/EvaluatedOrders.module.css";
import { Empty } from "../../components/Empty";
import { UserCircle } from "../../components/Icons";
import { If } from "../../components/control-statements";
import { ForEach } from "../../components/control-statements/ForEach";
import { Icon } from "../../components/core/Icon";
import { Environment } from "../../core/Environment";
import { Dates } from "../../utils/Dates";
import { Phone } from "../../utils/Phone";

const st = (className) => styles[className];

export const EvaluatedOrders = ({ average, units, brands, loading }) => {
  const environmentLogo =
    Environment.configurations?.wallet?.configs?.logo || null;

  const cx = classNames.bind(styles);
  const [orders, setOrders] = useState([]);

  const mountCategory = () => {
    const averageItems = [...average];
    for (const item of averageItems) {
      item.delivery = { ...(item.delivery || {}), name: "Entrega" };
      item.environment = {
        ...(item.environment || {}),
        name: "Ambiente",
      };
      item.experience = {
        ...(item.experience || {}),
        name: "Experiência",
      };
      item.product = { ...(item.product || {}), name: "Produto" };
      item.service = { ...(item.service || {}), name: "Serviço" };

      const categories = [
        item.delivery,
        item.environment,
        item.experience,
        item.product,
        item.service,
      ];

      item.collapsed = true;
      item.categories = categories.filter((item) => item.evaluate !== null);
    }

    setOrders(averageItems);
  };

  const changeCollapsed = (index) => {
    setOrders((prevState) => {
      prevState[index].collapsed = !prevState[index]?.collapsed;
      return [...prevState];
    });
  };

  const mountAverageItem = (categories) => {
    const media = (categories || []).reduce(
      (acc, item) => acc + (item.evaluate || 0),
      0
    );
    return (media / (categories || [1]).length).toFixed(1);
  };

  useEffect(() => {
    if (average) {
      mountCategory();
    }
  }, [average]);

  const sortedOrders = orders.sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at)
  );

  return (
    <div>
      <div className={st("orders")}>
        <If cond={(sortedOrders || []).length > 0}>
          <ForEach
            items={sortedOrders}
            render={(order, index) => (
              <div
                className={cx({
                  order: true,
                  // bad: order.overall_average < 3,
                  // good: order.overall_average >= 3,
                  good: true,
                })}
              >
                <div
                  className={st("header")}
                  onClick={() => changeCollapsed(index)}
                >
                  <div className="d-flex flex-column">
                    <p className={st("order-number")}>
                      Pedido <b>#{order.display_id}</b>
                    </p>
                    <span className={st("date")}>
                      {Dates.toDateTimeBRL(order.created_at)}
                    </span>
                    <div className={styles.brand}>
                      <div className={styles.logo}>
                        <img
                          src={brands[order?.brand_id]?.logo || environmentLogo}
                          alt=""
                        />
                      </div>

                      <p>
                        {brands[order?.brand_id]?.name || "Sem marca"}{" "}
                        <span>•</span> {units[order?.unit_id]?.name}
                      </p>
                    </div>
                  </div>

                  <div className="d-flex align-center">
                    <div className={st("star")}>
                      <Icon name="fa-star" solid size="2xs" />
                    </div>
                    <span className={st("rating")}>
                      {mountAverageItem(order.categories)}
                    </span>
                    <div
                      className={cx({
                        chevron: true,
                        collapsed: !order.collapsed,
                      })}
                    >
                      <Icon name="fa-chevron-down" size="1x" />
                    </div>
                  </div>
                </div>

                <If cond={!order.collapsed}>
                  <div className={st("content")}>
                    <div className={styles.user}>
                      <UserCircle />
                      <div className="d-flex flex-column">
                        <p className={styles.name}>
                          {order.customer_name || "Sem nome registrado"}
                        </p>
                        <div className={styles.phoneEmail}>
                          {order.customer_phone
                            ? Phone.format(order.customer_phone)
                            : ""}
                          {order.customer_phone && order.customer_email
                            ? " / "
                            : ""}
                          {order.customer_email || ""}
                        </div>
                      </div>
                    </div>
                    <ForEach
                      items={order.categories}
                      render={(category) => (
                        <div className={st("category")}>
                          <div className="d-flex align-center">
                            <div className={st("star")}>
                              <Icon name="fa-star" size="1x" solid />
                            </div>
                            <span className={st("rating")}>
                              {category.evaluate}
                            </span>
                            <p className={st("type")}>{category.name}</p>
                          </div>
                          <div className={st("tags")}>
                            <ForEach
                              items={category.items.slice(0, 3)}
                              render={(tag) => (
                                <div className={st("tag")}>{tag}</div>
                              )}
                            />
                          </div>
                        </div>
                      )}
                    />
                    {order?.obs && (
                      <>
                        <p className={st("comment")}>Comentário</p>
                        <p className={st("message")}>{order?.obs}</p>
                      </>
                    )}
                  </div>
                </If>
              </div>
            )}
          />
        </If>
        <If cond={(orders || []).length <= 0}>
          <Empty>
            <Icon name="fa-list-timeline" size="4x" />
            <p>Você ainda não tem avaliações.</p>
            <span>Todas as avaliações irão aparecer aqui.</span>
          </Empty>
        </If>
      </div>
    </div>
  );
};
